import React, { useEffect, useState } from 'react'
import CountUp from 'react-countup'
import axios from 'axios'
import Loader from 'react-js-loader'
import Swal from 'sweetalert2'
import loader from '../loader.gif'
import { useHistory, Link, useLocation } from 'react-router-dom'
import { Doughnut, Bar } from 'react-chartjs-2'
import { apiRequest } from '../store/allApi'
import { dateFormat, dateFormat1 } from '../utils/dateTime'
const $ = require("jquery");
$.Datatable = require("datatables.net");

const AgentDash = () => {
  const [loading, setLoading] = useState(false)
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [startDate1, setStartDate1] = useState("")
  const [endDate1, setEndDate1] = useState("")
  const [Agent, setAgent] = useState([])
  const [AgentAll, setAgentAll] = useState("")
  const [agentWallet, setAgentWallet] = useState({})
  const [olddayaData, set30DayaAllData] = useState([])
  const [Admin, setAdmin] = useState(0)
  const [User, setUser] = useState(0)
  const [user, setuser] = useState();
  const [challenge, setchallenge] = useState();
  const [txn, setTxn] = useState();
  const [txnwith, setTxnwith] = useState();
  const [bonus, setBonus] = useState();
  const [penalty, setPenalty] = useState();
  const [wallet, setWallet] = useState();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const history = useHistory()
  const location = useLocation()

  const meedata = localStorage.getItem("uData");
  const userData = JSON.parse(meedata);

  const path = location.pathname.split("/")[3] || userData?.id

 function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hour}:${minute}`;
  }

  const admin = async ( s1, e1) => {
    setLoading(true)

    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    // console.log("API call URL:", `agent/alldata/${path}?startingfrom=${s}&endto=${e}&start=${s1}&end=${e1}`)
    // let url = `agent/alldata/${path}?startingfrom=${s}&endto=${e}&start=${s1}&end=${e1}`
    let url = `agent/alldata/${path}?startingfrom=${s1}&endto=${e1}`

    try {
      const res = await apiRequest(`${url}`, "GET", null, headers)
      console.log(res.data,"resi")

      if (res) {
        setLoading(false)
        setAgentAll(res.data)
      }
    } catch (e) {
      setLoading(false)
    }
    finally {
    }
  }
  const admin1 = async () => {
    setLoading(true)

    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    // console.log("API call URL:", `agent/alldata/${path}?startingfrom=${s}&endto=${e}&start=${s1}&end=${e1}`)
    // let url = `agent/alldata/${path}?startingfrom=${s}&endto=${e}&start=${s1}&end=${e1}`
    let url = `get_allagentdata/${path}`

    try {
      const res = await apiRequest(`${url}`, "GET", null, headers)
      console.log(res.data,"resi")

      if (res) {
        setLoading(false)
        set30DayaAllData(res.data?.thirtyDaysData)
      }
    } catch (e) {
      setLoading(false)
    }
    finally {
    }
  }
  function daterange (s, e) {
    console.log("daterange inputs:", s, e)
    let start = new Date(s);
    let end = new Date(e);
    if (start > end) {
      // Swap dates if start is greater than end
      const temp = start;
      start = end;
      end = temp;
    }
    setStartDate(start)
    setEndDate(end)
    const formattedStart = formatDate(start)
    const formattedEnd = formatDate(end)
    console.log("Formatted dates:", formattedStart, formattedEnd)
    setStartDate1(formattedStart)
    setEndDate1(formattedEnd)
  }
  const AgentWallet = async () => {
    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = await apiRequest(`admin/me_agent/${path}`, "GET", null, headers)
      if (res.data) {
        setAgentWallet(res.data)
      }
    } catch (e) {
      // setLoading(false)

    }
    finally {
    }
  }

  const bonusHis = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`bonus_history/agnent/${path}`, "GET", null, headers)
      if (res.data) {
        setLoading(false);
        setchallenge(undefined);
        setTxn(undefined);
        setTxnwith(undefined);
        setPenalty(undefined);
        setWallet(undefined);
        setBonus(res.data);

        // console.log(res.data)
        $("table").dataTable();
      }
    } catch (e) {
      console.log(e);
      setLoading(false);

    }
    finally {
    }
  };
  const penaltyHis = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`penalty_history/agent/${path}`, "GET", null, headers)
      if (res.data) {
        setLoading(false);
        setchallenge(undefined);
        setTxn(undefined);
        setTxnwith(undefined);


        setPenalty(res.data);
        setBonus(undefined);
        setWallet(undefined);

        // console.log(res.data)
        $("table").dataTable();
      }
    } catch (e) {
      console.log(e);
      setLoading(false);

    }
    finally {
    }
  };

  const transactionHis = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`txn_history/agent/${path}`, "GET", null, headers)
      if (res.data) {
        setLoading(false);
        setchallenge(undefined);

        setBonus(undefined);
        setPenalty(undefined);
        setWallet(undefined);

        setTxnwith(undefined);

        setTxn(res.data);
        $("table").dataTable();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);

    }
    finally {
    }
  };
  const withdrawalHis = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`withdraw_history/agent/${path}`, "GET", null, headers)
      if (res.data) {
        setLoading(false);
        setTxn(undefined);
        setchallenge(undefined);

        setBonus(undefined);
        setPenalty(undefined);
        setWallet(undefined);


        setTxnwith(res.data);
        $("table").dataTable();
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
    finally {
    }
  };
  const Allchallenge = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`get_challange/agent/${path}`, "GET", null, headers)
      if (res.data) {
        setLoading(false);
        setTxn(undefined);
        setTxnwith(undefined);

        setBonus(undefined);
        setPenalty(undefined);
        setWallet(undefined);


        setchallenge(res.data);
        // setNumberOfPages(res.data.totalPages);
        $("table").dataTable();
        // console.log(path)
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
    finally {
    }
  };
  const WalletHis = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`history/Security_Deposit/${path}`, "GET", null, headers)
      if (res.data) {
        setLoading(false);
        setTxn(undefined);
        setTxnwith(undefined);

        setBonus(undefined);
        setPenalty(undefined);
        setWallet(undefined);


        setchallenge(undefined);
        setWallet(res.data);
        // setNumberOfPages(res.data.totalPages);
        $("table").dataTable();
        // console.log(path)
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
    finally {
    }
  };

  const checkfailedpayout = async (txn_id, referenceId) => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`payout/response/api`, "POST", { txn_id, referenceId }, headers)
      if (res.data) {
        setLoading(false);
        const icon = res.data.status == "SUCCESS" ? "success" : "danger";
        const title =
          res.data.status == "SUCCESS"
            ? "Withdraw successfully"
            : "Transaction Proccessing or Failed";
        withdrawalHis();
        alert(title);
      }
    } catch (e) {
      setLoading(false);
      if (e.response.status == 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('uData');
        localStorage.removeItem('PData');
        window.location.reload();
      }
    }
    finally {
    }
  };

  function daterange (s, e) {
    let start = new Date(s);
    let end = new Date(e);
    if (start > end) {
      // Swap dates if start is greater than end
      const temp = start;
      start = end;
      end = temp;
    }
    setStartDate(start)
    setEndDate(end)
    setStartDate1(formatDate(start))
    setEndDate1(formatDate(end))
  }

  const DateFilter = () => {
    admin(startDate1, endDate1)
  }

  useEffect(() => {
    const now = new Date();
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    admin(formatDate(start), formatDate(now))
    // Allchallenge()
    AgentWallet()
    admin1()
  }, [])
  


  const labels = olddayaData?.map(data => {
    const dateObject = new Date(data?.updatedAt);
    const monthNumber = dateObject.getMonth() + 1; // Adding 1 to get month number (0-indexed)
    const day = dateObject.getDate();
    return `${day}/${monthNumber}`;
  });


  const depositOtion = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: false,
            fontColor: 'white' // Set the color of the y-axis tick labels
          }
        }
      ],
      xAxes: [
        {
          ticks: {
            fontColor: 'white' // Set the color of the y-axis tick labels
          }
        }
      ]
    },
    legend: {
      display: false,
      position: 'top'
    }
  }

  const depositData = {
    labels,
    datasets: [
      {
        label: 'Deposit',
        data: olddayaData.map(data => data?.totaldepositamount),
        backgroundColor: [
          '#a343ff',
          '#00b3ff',
          '#f5334f',
          '#30c102',
          '#FFEB3B',
          'blue',
          'white',
          '#a343ff',
          '#00b3ff',
          '#f5334f',
          '#30c102',
          '#FFEB3B',
          'blue',
          'white',
          '#a343ff',
          '#00b3ff',
          '#f5334f',
          '#30c102',
          '#FFEB3B',
          'blue',
          'white',
          '#a343ff',
          '#00b3ff',
          '#f5334f',
          '#30c102',
          '#FFEB3B',
          'blue',
          'white',
          '#a343ff',
          '#00b3ff',
        ]
      }
    ]
  }
  const withdrawOption = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: false,
            fontColor: 'white' // Set the color of the y-axis tick labels
          }
        }
      ],
      xAxes: [
        {
          ticks: {
            fontColor: 'white' // Set the color of the y-axis tick labels
          }
        }
      ]
    },
    legend: {
      display: false,
      position: 'top'
    }
  }

  const withdrawData = {
    labels,
    datasets: [
      {
        label: 'Withdrawl',
        data: olddayaData.map(data => data?.totalwithdrawamount),
        backgroundColor: [
          '#a343ff',
          '#00b3ff',
          '#f5334f',
          '#30c102',
          '#FFEB3B',
          'blue',
          'white',
          '#a343ff',
          '#00b3ff',
          '#f5334f',
          '#30c102',
          '#FFEB3B',
          'blue',
          'white',
          '#a343ff',
          '#00b3ff',
          '#f5334f',
          '#30c102',
          '#FFEB3B',
          'blue',
          'white',
          '#a343ff',
          '#00b3ff',
          '#f5334f',
          '#30c102',
          '#FFEB3B',
          'blue',
          'white',
          '#a343ff',
          '#00b3ff',
        ]
      }
    ]
  }

  const imageopen = (image) => {
    Swal.fire({
      title: "Image",
      text: "",

      imageUrl: baseUrl + image,
      imageWidth: 400,
      imageHeight: 300,
      imageAlt: "Custom image"
    })
  }


  return loading ? (
    <div className='App'>
      <div className='item dashboaed_loader'>
        <Loader
          type='bubble-ping'
          bgColor={'#fff'}
          title={<img src={loader} alt='Loading...' />}
          color={'#000'}
          size={100}
        />
      </div>
    </div>
  ) : (
    <>

      <div className=''>
        <div className='row mt-3'>
          <div className='col-xl-12 col-sm-12 d_flex_both_center'>
            <h1 className='dashboard_heading'>Your Dashboard</h1>
            <div className='mb-3 pt-4'>
            <input
              type="datetime-local"
              name="DOB"
              placeholder="Select Data"
              value={startDate1}   onChange={(e) => daterange(e.target.value, endDate1)}
              required
            />
<span className='mx-3'>T0</span>

            <input
              type="datetime-local"
              name="DOB"
              placeholder="Select Data"
              value={endDate1} onChange={(e) => daterange(startDate1, e.target.value)}
              required
            />
              <button className="btn btn-success mx-3" onClick={() => {
                console.log("DateFilter called with:", startDate1, endDate1);
                DateFilter();
              }}>Submit</button>
            </div>
          </div>




          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title'>TODAY DEPOSIT</h3>
              </div>
              <div className='card-body pt-0'>
                <h3 className='mb-2 font-rubik'>
                  <CountUp start={0} delay={0.1} duration={0.2} end={AgentAll && AgentAll.todayDeposit} />
                </h3>
              </div>
            </div>
          </div>
          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title'>TODAY MANUAL DEPOSIT</h3>
              </div>
              <div className='card-body pt-0'>
                <h3 className='mb-2 font-rubik'>
                  <CountUp start={0} delay={0.1} duration={0.2} end={AgentAll && AgentAll?.todayDepositManual} />
                </h3>
              </div>
            </div>
          </div>


          {userData.user_type == 'Admin' ? (
          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title'>TOTAL DEPOSIT</h3>
              </div>
              <div className='card-body pt-0'>
                <h3 className='mb-2 font-rubik'>
                  <CountUp start={0} delay={0.1} duration={0.2} end={AgentAll && AgentAll.totalDeposit} />
                </h3>
              </div>
            </div>
          </div>
          ):""}
          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title'>TODAY WITHDRAW</h3>
              </div>
              <div className='card-body pt-0'>
                <h3 className='mb-2 font-rubik'>
                  <CountUp start={0} delay={0.1} duration={0.2} end={AgentAll && AgentAll.todayWithdraw} />
                </h3>
              </div>
            </div>
          </div>
          
          {userData.user_type == 'Admin' ? (
          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title'>TOTAL WITHDRAW</h3>
              </div>
              <div className='card-body pt-0'>
                <h3 className='mb-2 font-rubik'>
                  <CountUp start={0} delay={0.1} duration={0.2} end={AgentAll && AgentAll.totalWithdraw} />
                </h3>
              </div>
            </div>
          </div>
          ):""}
          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title'>TODAY BONUS</h3>
              </div>
              <div className='card-body pt-0'>
                <h3 className='mb-2 font-rubik'>
                  <CountUp start={0} delay={0.1} duration={0.2} end={AgentAll && AgentAll.todayBouns} />
                </h3>
              </div>
            </div>
          </div>
          {userData.user_type == 'Admin' ?
            <div className='col-xl-3 col-sm-6'>
              <div className='card dashboard_small_card card_hover'>
                <div className='card-header border-bottom-0'>
                  <h3 className='card-title'>TOTAL BONUS</h3>
                </div>
                <div className='card-body pt-0'>
                  <h3 className='mb-2 font-rubik'>
                    <CountUp start={0} delay={0.1} duration={0.2} end={AgentAll && AgentAll.totalBouns} />
                  </h3>
                </div>
              </div>

            </div>
            : ""}
          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title'>TODAY PENALTY</h3>
              </div>
              <div className='card-body pt-0'>
                <h3 className='mb-2 font-rubik'>
                  <CountUp start={0} delay={0.1} duration={0.2} end={AgentAll && AgentAll.todayPenalty} />
                </h3>
              </div>
            </div>
          </div>
          {userData.user_type == 'Admin' ?
            <div className='col-xl-3 col-sm-6'>
              <div className='card dashboard_small_card card_hover'>
                <div className='card-header border-bottom-0'>
                  <h3 className='card-title'>TOTAL PENALTY</h3>
                </div>
                <div className='card-body pt-0'>
                  <h3 className='mb-2 font-rubik'>
                    <CountUp start={0} delay={0.1} duration={0.2} end={AgentAll && AgentAll.totalPenalty} />
                  </h3>
                </div>
              </div>
            </div>
            : ""}
          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title'>Balance</h3>
              </div>
              <div className='card-body pt-0'>
                <h3 className='mb-2 font-rubik'>
                  <CountUp start={0} delay={0.1} duration={0.2} end={agentWallet && agentWallet.Wallet_balance} />
                </h3>
              </div>
            </div>
          </div>
          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title'>Today Admin Balance </h3>
              </div>
              <div className='card-body pt-0'>
                <h3 className='mb-2 font-rubik'>
                  <CountUp start={0} delay={0.1} duration={0.2} end={AgentAll && AgentAll.todayDepositManualAdmin} />
                </h3>
              </div>
            </div>
          </div>

        </div>

        <div className="row ">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body table_bg">
                <button
                  className={
                    Boolean(challenge)
                      ? `btn btn-success mb-3 mr-2`
                      : `btn btn-info mb-3 mr-2`
                  }
                  onClick={Allchallenge}
                >
                  Game History
                </button>

                <button
                  className={
                    Boolean(txn)
                      ? `btn btn-success mb-3 mr-2`
                      : `btn btn-info mb-3 mr-2`
                  }
                  onClick={transactionHis}
                >
                  Deposit History
                </button>
                <button
                  className={
                    Boolean(txnwith)
                      ? `btn btn-success mb-3 mr-2`
                      : `btn btn-info mb-3 mr-2`
                  }
                  onClick={withdrawalHis}
                >
                  withdrawal History
                </button>

                <button
                  className={
                    Boolean(bonus)
                      ? `btn btn-success mb-3 mr-2`
                      : `btn btn-info mb-3 mr-2`
                  }
                  onClick={bonusHis}
                >
                  Bonus History
                </button>
                <button
                  className={
                    Boolean(penalty)
                      ? `btn btn-success mb-3 mr-2`
                      : `btn btn-info mb-3 mr-2`
                  }
                  onClick={penaltyHis}
                >
                  Penalty History
                </button>
                <button
                  className={
                    Boolean(wallet)
                      ? `btn btn-success mb-3 mr-2`
                      : `btn btn-info mb-3 mr-2`
                  }
                  onClick={WalletHis}
                >
                  Balance Wallet
                </button>



                {Boolean(challenge) && (
                  <div className="table-responsive">
                    <table className="table table_bg">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th> ID</th>
                          <th> Creator</th>
                          <th> Accepter</th>
                          <th> Amount </th>
                          <th> Win/Lose Amt </th>
                          <th> closing balance</th>
                          <th> Status </th>
                          <th> Game Type </th>
                          <th> Winner </th>
                          <th> Date </th>
                          <th> Action </th>
                        </tr>
                      </thead>

                      <tbody>
                        {challenge &&
                          challenge?.map((game, key) => (
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>{game?._id ? game?._id : null}</td>
                              <td>
                                <span className="pl-2 ">
                                  {game.Created_by
                                    ? game.Created_by.Name
                                    : null}
                                </span>
                              </td>

                              <td>
                                <span className="pl-2">
                                  {game.Accepetd_By
                                    ? game.Accepetd_By.Name
                                    : null}
                                </span>
                              </td>
                              <td>{game.Game_Ammount}</td>

                              <td>
                                {game.Winner
                                  ? user?._id == game.Winner?._id
                                    ? "+" + game.winnAmount
                                    : "-" + game.Game_Ammount
                                  : user?._id == game.Created_by?._id
                                    ? game.winnAmount
                                    : "-" + game.winnAmount}
                              </td>

                              <td>
                                {game.Winner
                                  ? user?._id == game.Winner?._id
                                    ? game.Winner_closingbalance
                                    : game.Loser_closingbalance
                                  : user?._id == game.Created_by?._id
                                    ? game.Loser_closingbalance
                                    : game.Winner_closingbalance}
                              </td>
                              <td className="text-primary font-weight-bold">
                                {game.Status}
                              </td>
                              <td>{game.Game_type}</td>
                              <td>{game.Winner ? game.Winner.Name : null}</td>

                              <td>{dateFormat(game.updatedAt)} </td>


                              <td>
                                <Link
                                  type="button"
                                  className="btn btn-primary mx-1"
                                  to={`/view/${game._id}`}
                                >
                                  View
                                </Link>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {Boolean(txn) && (
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th> ID</th>
                          <th> Amount </th>
                          <th> Closing balance</th>
                          <th> Status </th>
                          <th> Payment gatway </th>
                          <th>created At</th>
                          <th>updated At</th>
                        </tr>
                      </thead>
                      <tbody>
                        {txn.map((data, key) => (
                          <tr key={key}>
                            <td>{key + 1}</td>
                            <td>{data._id}</td>

                            <td>{data.amount}</td>
                            <td> {data.closing_balance}</td>
                            <td className="font-weight-bold text-success">
                              {data.status}
                            </td>
                            <td>
                              {" "}
                              {data.payment_gatway ? data.payment_gatway : ""}
                            </td>
                           
                            <td>{dateFormat1(data.createdAt)} </td>

                            <td>{dateFormat1(data.updatedAt)} </td>

                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {Boolean(txnwith) && (
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th> ID</th>

                          <th> type</th>
                          <th> Amount </th>
                          <th> Closing balance</th>
                          <th> Account Number</th>
                          <th> IFSC</th>
                          <th> Upi Id</th>
                          <th> Status </th>
                          <th> Approve By </th>
                          <th> Action </th>
                          <th> created At </th>
                          <th> updated At </th>
                        </tr>
                      </thead>
                      <tbody>
                        {txnwith &&
                          txnwith.map((data, key) => (
                            <tr>
                              <td>{key + 1}</td>
                              <td>{data._id}</td>

                              <td>
                                <span className="pl-2">
                                  {data.Withdraw_type}
                                </span>
                              </td>
                              <td>{data.amount}</td>
                              <td> {data.admin_closing_balance}</td>
                              <td> {data.bankDetail?.account_number}</td>
                              <td> {data.bankDetail?.ifsc_code}</td>
                              <td> {data.bankDetail?.upi_id}</td>
                              <td className="font-weight-bold text-success">
                                {data.status}
                              </td>
                              <td className="font-weight-bold">
                                {data?.action_by?.Name}
                              </td>
                              <td>
                                {
                                  //&& data.status != 'FAILED'
                                  data.status != "SUCCESS" &&
                                    data.amount == user?.withdraw_holdbalance ? (
                                    <button
                                      className="btn btn-danger"
                                      onClick={() =>
                                        checkfailedpayout(
                                          data._id,
                                          data.referenceId
                                        )
                                      }
                                    >
                                      Check {data.payment_gatway}
                                    </button>
                                  ) : (
                                    "Checked"
                                  )
                                }
                              </td>
                             
                            <td>{dateFormat1(data.createdAt)} </td>

                              <td>{dateFormat1(data.updatedAt)} </td>

                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {Boolean(bonus) && (
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th> ID</th>
                          <th> Amount </th>
                          <th>Closing Balance</th>
                          <th>Reason</th>
                          <th> Status</th>
                          <th> Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bonus.map((data, key) => {
                          // console.log(data.Game_Amount)
                          return (
                            <tr
                              key={key}
                              style={{
                                color:
                                  data.Req_type == "deposit"
                                    ? "green"
                                    : data.Req_type == "withdraw"
                                      ? "		#ff7f50"
                                      : "black",
                              }}
                            >
                              <td>{key + 1}</td>
                              <td>{data._id}</td>
                              <td>{data.amount}</td>
                              <td>{data.closing_balance}</td>
                              <td>{data.txn_msg}</td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  color:
                                    data.status == "SUCCESS"
                                      ? "seagreen"
                                      : data.status == "completed"
                                        ? "royalblue"
                                        : data.status == "cancelled"
                                          ? "salmon"
                                          : data.status == "FAILED"
                                            ? "red"
                                            : "black",
                                }}
                              >
                                {data.status}
                                {data.status == "PAID" ? (
                                  <span>&#9989;</span>
                                ) : data.status == "FAILED" ? (
                                  <span>&#10060;</span>
                                ) : (
                                  ""
                                )}
                              </td>
                              {/* <td>{data.date} </td> */}
                              {/* <td>
                                {moment(data.updatedAt).format(
                                  "MMMM Do YYYY, h:mm:ss a"
                                )}{" "}
                              </td> */}
                              <td>{dateFormat1(data.updatedAt)} </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
                {Boolean(penalty) && (
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th> ID</th>
                          <th> Amount </th>
                          <th>Closing Balance</th>
                          <th>Reason</th>
                          <th> Status</th>
                          <th> Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {penalty.map((data, key) => {
                          // console.log(data.Game_Amount)
                          return (
                            <tr
                              key={key}
                              style={{
                                color:
                                  data.Req_type == "deposit"
                                    ? "green"
                                    : data.Req_type == "withdraw"
                                      ? "		#ff7f50"
                                      : "black",
                              }}
                            >
                              <td>{key + 1}</td>
                              <td>{data._id}</td>
                              <td>{data.amount}</td>
                              <td>{data.closing_balance}</td>
                              <td>{data.txn_msg}</td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  color:
                                    data.status == "SUCCESS"
                                      ? "seagreen"
                                      : data.status == "completed"
                                        ? "royalblue"
                                        : data.status == "cancelled"
                                          ? "salmon"
                                          : data.status == "FAILED"
                                            ? "red"
                                            : "black",
                                }}
                              >
                                {data.status}
                                {data.status == "PAID" ? (
                                  <span>&#9989;</span>
                                ) : data.status == "FAILED" ? (
                                  <span>&#10060;</span>
                                ) : (
                                  ""
                                )}
                              </td>
                              {/* <td>{data.date} </td> */}
                              <td>{dateFormat1(data.updatedAt)} </td>

                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
                {Boolean(wallet) && (
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th> ID</th>
                          <th> Amount </th>
                          <th>Closing Balance</th>
                          <th>Reason</th>
                          <th>Image</th>
                          <th> Status</th>
                          <th> Action By</th>
                          <th> Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {wallet.map((data, key) => {
                          // console.log(data.Game_Amount)
                          return (
                            <tr
                              key={key}
                              style={{
                                color:
                                  data.Req_type == "deposit"
                                    ? "green"
                                    : data.Req_type == "withdraw"
                                      ? "		#ff7f50"
                                      : "black",
                              }}
                            >
                              <td>{key + 1}</td>
                              <td>{data._id}</td>
                              <td>{data.amount}</td>
                              <td>{data.closing_balance}</td>
                              <td>{data.txn_msg}</td>

                              <td>
                              
                                <img src={baseUrl + `${data.paymentImage}`}
                                  onClick={() => imageopen(data.paymentImage)}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "/error.png";
                                  }}
                                />
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  color:
                                    data.status == "SUCCESS"
                                      ? "seagreen"
                                      : data.status == "completed"
                                        ? "royalblue"
                                        : data.status == "cancelled"
                                          ? "salmon"
                                          : data.status == "FAILED"
                                            ? "red"
                                            : "red",
                                }}
                              >
                                {data.status}
                                {data.status == "PAID" ? (
                                  <span>&#9989;</span>
                                ) : data.status == "FAILED" ? (
                                  <span>&#10060;</span>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td>{data?.action_by?.Name}</td>

                              {/* <td>{data.date} </td> */}
                              <td>{dateFormat1(data.updatedAt)} </td>

                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {userData.user_type == 'Admin' ?
          <div className='row mt-3'>
            <div className='col-xl-6 col-sm-12'>
              <div className='card dashboard_small_card  dashboard_graph_card'>
                <div className='grapg_header'>
                  <h2 className=''>Deposit Payment</h2>
                </div>
                <div className='graph_box'>
                  <Bar data={depositData} options={depositOtion} />
                </div>
              </div>
            </div>
            <div className='col-xl-6 col-sm-12'>
              <div className='card dashboard_small_card  dashboard_graph_card'>
                <div className='grapg_header'>
                  <h2 className=''>Withdraw Payment</h2>
                </div>
                <div className='graph_box'>
                  <Bar data={withdrawData} options={withdrawOption} />
                </div>
              </div>
            </div>
          </div>
          : ""}
      </div>

    </>
  )
}

export default AgentDash
